import { render, staticRenderFns } from "./Modulecreate.vue?vue&type=template&id=9e9d3792&"
import script from "./Modulecreate.vue?vue&type=script&lang=js&"
export * from "./Modulecreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports